import {useMutation, UseMutationResult} from "react-query";
import {API, CustomAxiosError} from "../../../../logics/api-config";


async function doCreate(invoice_data: any): Promise<void> {
    try {
        await API.postFormData(`/accounting/bills/monthly`, invoice_data);
    } catch (error) {
        throw error;
    }
}

const useApiCreateWorking = (): UseMutationResult<void, CustomAxiosError, any, unknown> => {
    return useMutation<void, CustomAxiosError, any>(data => doCreate(data));
};

export default useApiCreateWorking;